import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import { Button, Fade, ListItem, MenuItem, Typography } from '@material-ui/core'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import '../Dashboard.css'
import SEO from '@/utils/SEO'
import { useTranslation } from 'react-i18next'

const Commoncomp = (props) => {
    const formikSearch = props.formikSearch
    const sortShow = props.sortShow
    const pageOptions = props.pageOptions
    const { t } = useTranslation()
    return (
        <>
            {/* <SEO title="My Bids gh" url={window.location.href} /> */}
            <div
                className={
                    props?.auctionDetails == undefined
                        ? 'searchMiscFilters parent w-100 mb-3 d-flex justify-content-between align-items-center '
                        : 'searchMiscFilters parent w-100 mb-3 d-flex justify-content-between align-items-center liveAuctionGridBg'
                }
            >
                {/* {props.path && (
                    <Breadcrumbs aria-label="breadcrumb" className="customBreadcrumbs">
                        <Link to="/auctions/all">{location.pathname.split('/')[1]}</Link>
                        <Typography color="textPrimary">
                            {props.renderHeading(location.pathname.split('/')[2])}
                        </Typography>
                    </Breadcrumbs>
                )} */}
                {props.search && props?.auctionDetails == undefined ? (
                    <h3 className="assetsHeader mb-0">All Assets</h3>
                ) : (
                    <h3 className="assetsHeader mb-0">{props?.auctionDetails?.title}</h3>
                )}
                <div
                    className="searchMiscFilters flex-wrap d-flex justify-content-end align-items-end"
                    style={{ gap: '8px' }}
                >
                    {props.viewSwitch && (
                        <div className="gridListToggle">
                            <Button
                                id="myauctions_grid"
                                className={props.auctionView === 'Grid' ? 'active' : ''}
                                onClick={() => props.setAuctionView('Grid')}
                            >
                                <span className="material-icons">apps</span>
                            </Button>
                            <Button
                                id="myauctions_list"
                                className={props.auctionView === 'List' ? 'active' : ''}
                                onClick={() => props.setAuctionView('List')}
                            >
                                <span className="material-icons">view_list</span>
                            </Button>
                        </div>
                    )}
                    {props.resultPerPage && (
                        <CustomSelect
                            label="Results"
                            name="resultsPerPage"
                            selectType="noBorder"
                            size="small"
                            value={formikSearch.values.limit}
                            onChange={(event, editor) => {
                                formikSearch.setFieldValue('limit', event.target.value)
                            }}
                        >
                            {pageOptions.map((opt, optindex) => (
                                <option value={opt.value}>{opt.show}</option>
                            ))}
                        </CustomSelect>
                    )}
                    {props.sortBy && (
                        <CustomSelect
                            label=""
                            value={formikSearch.values.orderby}
                            size="small"
                            selectType="noBorder"
                            name="orderby"
                            // shrink={search.orderby !== '' ? true : false}
                            onChange={(event, editor) => {
                                formikSearch.setFieldValue('orderby', event.target.value)
                            }}
                        >
                            {sortShow.map((opt, optindex) => (
                                <option value={opt.value}>{opt.show}</option>
                            ))}
                        </CustomSelect>
                    )}
                </div>
            </div>
        </>
    )
}

export default Commoncomp
